import * as React from 'react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { IStackTokens, Stack } from 'office-ui-fabric-react/lib/Stack';
import { Label } from 'office-ui-fabric-react/lib/Label';
import Header from '../Header';
import './Loader.scss';
import { ILoaderProps, ILoaderState } from '../../../interfaces/ILoader';

export default class Loader extends React.Component<ILoaderProps, ILoaderState> {
    constructor(props: ILoaderProps) {
        super(props);

        this.state = {
        }
    }

    public render() {
        return (
            <div className="page">
                <Header isBackVisible={false} />
                <div className="container mt-12 padd120">
                    <Label className="text-center" >
                        <div dangerouslySetInnerHTML={{ __html: this.props.PageTitle }}></div>
                    </Label>

                    <Spinner label="Even geduld aub..." size={SpinnerSize.large} />
                </div>
            </div>
        );
    }
}
